class User {
  constructor() {
    this.init();
  }

  init() {
    this.user_id = undefined;
    this.first_name = undefined;
    this.last_name = undefined;
    this.email = undefined;
    this.phone_number = undefined;
    this.notification = undefined;
    this.title = undefined;
    this.avatar = undefined;
    this.parent_id = undefined;
    this.provider_id = undefined;
    this.partner_id = undefined;
    this.kinside_responsibilites = undefined;
  }

  copy() {
    const cp = new User();

    cp.user_id = this.user_id;
    cp.first_name = this.first_name;
    cp.last_name = this.last_name;
    cp.email = this.email;
    cp.phone_number = this.phone_number;
    cp.title = this.title;
    cp.avatar = this.avatar;
    cp.parent_id = this.parent_id;
    cp.provider_id = this.provider_id;
    cp.partner_id = this.partner_id;
    cp.kinside_responsibilites = this.kinside_responsibilites;
    if (this.notification) {
      cp.notification = Object.assign({}, this.notification);
    }

    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      this.user_id = obj.user_id ? obj.user_id.toString() : undefined;
      this.first_name = obj.first_name ? obj.first_name : undefined;
      this.last_name = obj.last_name ? obj.last_name : undefined;
      this.email = obj.email ? obj.email : undefined;
      this.phone_number = obj.phone_number ? obj.phone_number : undefined;
      this.notification = obj.notification ? Object.assign({}, obj.notification) : undefined;
      this.title = obj.title ? obj.title : undefined;
      this.avatar = obj.avatar ? obj.avatar : undefined;
      this.parent_id = obj.parent_id ? obj.parent_id.toString() : undefined;
      this.provider_id = obj.provider_id ? obj.provider_id.toString() : undefined;
      this.partner_id = obj.partner_id ? obj.partner_id.toString() : undefined;
      this.kinside_responsibilites = obj.kinside_responsibilites || [];
    }
  }

  toString() {
    let result = this.username ? this.username : (this.name ? this.name : '');
    return result;
  }

  getId() {
    return this.user_id;
  }

  setId(user_id) {
    this.user_id = user_id ? user_id.toString() : undefined;
  }

  getFirstName() {
    return this.first_name;
  }

  setFirstName(first_name) {
    this.first_name = first_name;
  }

  getLastName() {
    return this.last_name;
  }

  setLastName(last_name) {
    this.last_name = last_name;
  }

  getEmail() {
    return this.email;
  }

  setEmail(email) {
    this.email = email;
  }

  getPhoneNumber() {
    return this.phone_number;
  }

  setPhoneNumber(phone_number) {
    this.phone_number = phone_number;
  }
  
  getTitle() {
    return this.title;
  }

  setTitle(title) {
    this.title = title;
  }
  
  getAvatar() {
    return this.avatar;
  }

  setAvatar(avatar) {
    this.avatar = avatar;
  }

  getNotification() {
    return this.notification;
  }

  setNotification(notification) {
    this.notification = (notification) ? Object.assign({}, notification) : undefined;
  }

  // Read only properties
  getParentId() {
    return this.parent_id;
  }

  getProviderId() {
    return this.provider_id;
  }

  getPartnerId() {
    return this.partner_id;
  }

  getName() {
    let result = this.first_name || '';

    if (this.last_name && this.last_name.length) {
      result = (result.length) ? `${result} ${this.last_name}` : this.last_name;
    }
    if (!result.length) {
      result = 'User';
    }

    return result;
  }

  getKinsideResponsibilites() {
    return this.kinside_responsibilites;
  }

  isResponsibleFor(action) {
    return this.kinside_responsibilites.includes(action);
  }
}

module.exports = User;
